import(/* webpackMode: "eager", webpackExports: ["HomeProfile"] */ "/app/next/src/components/homes/profile/page.tsx");
